import React from "react";
import { Switch, Table } from "antd";
import { useMarketingListModel } from "../allMemberMarketingListModel";
import { ColumnsType } from "antd/es/table";
import { IMarketingRecordDetail } from "../allMemberMarketingListTypes";
import moment from "moment";
import { getBaseImgLookUrl } from "@src/utils/constants";
import { momentFormats } from "@src/utils/utils";
import { YhAuth } from "@src/components/auth/YhAuth";
import { YhBut } from "@src/components/YhButton";
import { EditModeType } from "@src/types/FmsTypes";
import { projectProposalStatusList } from "../allMemberMarketingListTypes";


export function DataTable() {
    const {
        dataSource,
        pgCfg,
        loadData,
        setDrawerVisible,
        setSelectedRow,
        setEditType,
    } = useMarketingListModel();


    const onDetail = (type: EditModeType, data: IMarketingRecordDetail) => {
            console.log(data)
            setDrawerVisible(true)
            setSelectedRow(data)
            setEditType(type)
    }

    const columns: ColumnsType<IMarketingRecordDetail> = [
    {
        align: 'center',
        title: '序号',
        width: 60,
        render: (v, r, i) => i + 1
    },
    {
        align: "center",
        title: '编号',
        width: 100,
        dataIndex: 'proposalNo',
    },
    {
        align: "center",
        title: '状态',
        width: 100,
        dataIndex: 'status',
        render: (value) => {
            const item = projectProposalStatusList.find((item) => item.value === value);
            return item?.label || '-';
        }
    },
    {
        align: "left",
        title: '客户名称',
        width: 150,
        dataIndex: 'customerName',
    },
    {
        align: "center",
        title: '主营对接人',
        width: 100,
        dataIndex: 'specificPerson',
    },
    {
        align: "center",
        title: '联系人',
        width: 100,
        dataIndex: 'businessContact',
    },
    {
        align: "center",
        title: '联系电话',
        width: 100,
        dataIndex: 'businessContactPhone',
    },
    {
        align: "center",
        title: '信息有效期',
        width: 200,
        dataIndex: 'validTime',
        render: (value) => momentFormats(value)
    },
    {
        align: "center",
        title: '创建人',
        width: 100,
        dataIndex: 'createUser',
    },
    {
        align: "center",
        title: '创建时间',
        width: 200,
        dataIndex: 'createTime',
        render: (value) => momentFormats(value)
    },
     {
                align: "center",
                title: '操作',
                width: 120,
                dataIndex: 'enable',
                fixed: "right",
                render: (value, record, index) => {
                    return (
                        <>
                            <YhAuth resCode="portal2.am.type.vw">
                                <YhBut
                                    typeName="icon-chakan"
                                    text="查看"
                                    style={{ color: "#1296DB", fontSize: "18px" }}
                                    click={() => onDetail('look', record)}
                                />
                            </YhAuth>
                        </>
                    )
                }
            },
];



    return (
        <Table
            style={{ cursor: "pointer" }}
            columns={columns}
            dataSource={dataSource}
            rowKey={(record) => record.id || record.marketingRecordId}
            scroll={{ x: 'max-content' }}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
        />
    )
}


